var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgL09 = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0.00 0.00 263.00 455.00",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    transform: "translate(-2782.00, 0.00)",
    id: "L9_Copy"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2954.66,371.49 C2950.78,375.19 2942.07,381.55 2938.58,383.22 C2935.69,384.58 2928.83,385.98 2925.93,386.33 C2923.65,386.59 2916.91,386.86 2913.96,386.11 C2910.36,385.15 2905.17,383.34 2902.17,381.99 C2898.88,380.49 2892.59,376.33 2888.62,373.00 C2883.54,368.70 2880.06,365.17 2876.56,361.00 C2868.80,351.47 2850.05,327.19 2839.98,313.93 C2834.44,306.41 2824.12,291.41 2819.41,283.98 C2814.11,275.11 2807.00,261.94 2803.56,254.69 C2799.88,246.76 2794.26,231.90 2791.76,222.88 C2789.39,214.22 2786.42,197.19 2785.83,188.81 C2785.24,180.22 2786.98,142.21 2788.25,130.09 C2789.38,121.14 2793.07,104.41 2796.61,97.13 C2798.86,92.62 2809.19,79.82 2811.81,77.71 C2813.54,76.33 2819.96,72.66 2822.73,71.49 C2827.96,69.33 2846.54,66.95 2855.39,66.90 C2869.71,66.98 2902.60,67.33 2921.16,67.60 C2939.59,68.09 2973.09,69.26 2985.92,70.07 C2991.36,70.50 2996.96,71.38 3001.96,72.90 C3006.32,74.25 3011.02,77.16 3013.01,79.62 C3017.48,85.27 3021.72,94.21 3025.28,103.95 C3027.49,110.36 3033.11,127.97 3034.42,133.05 C3036.50,141.18 3039.79,159.80 3040.29,166.38 C3040.77,173.13 3041.30,187.04 3041.37,194.21 C3041.30,201.52 3040.77,216.71 3039.50,224.38 C3038.18,232.29 3033.47,248.86 3030.09,257.52 C3027.76,263.47 3020.95,277.46 3016.40,285.84 C3012.31,292.94 3003.21,307.48 2998.20,314.92 C2975.51,346.70 2955.26,370.90 2954.66,371.49 Z",
    fill: "none",
    stroke: "rgb(0, 0, 0)",
    strokeWidth: 10,
    strokeOpacity: 1,
    strokeLinejoin: "round"
  }))));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgL09, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/L-09.97f24c27.svg";
export { ForwardRef as ReactComponent };